<template>
    <q-card class="survey q-pa-xs"
        :inline="inline"
        :draggable="draggable"
        @dragstart.native="ondragstart">

        <q-card-main>
            <p>{{localModel.label}}</p>

            <div v-if="localModel.qualifying">
                <small>Kwalifikacyjna. Bieguny:</small>
                <ul>
                    <li v-for="pole in poles" :key="pole.poleId">
                        <small>{{pole.label}}</small>
                    </li>
                </ul>
            </div>
        </q-card-main>
    </q-card>
</template>

<script>
    import QIcon from 'quasar-framework/src/components/icon/QIcon'
    import QCardTitle from 'quasar-framework/src/components/card/QCardTitle'
    import QCardMain from 'quasar-framework/src/components/card/QCardMain'
    import QCardActions from 'quasar-framework/src/components/card/QCardActions'

    export default {
        name: 'SurveyViewer',
        components: {QCardActions, QCardMain, QCardTitle, QIcon},
        props: ['model', 'draggable', 'inline'],
        methods: {
            ondragstart (e) {
                e.dataTransfer.effectAllowed = 'copy'
                e.dataTransfer.setData('text', JSON.stringify(this.localModel))
            },
            fetchDetailsIfNecessary() {

            }
        },
        watch: {
            model(current) {
                this.localModel = current;
                this.fetchDetailsIfNecessary();
            }
        },
        mounted() {
            this.localModel = this.model;

            this.fetchDetailsIfNecessary();
        },
        data () {
            return {
                localModel: {
                    qualifying: false,
                    questions: []
                }
            }
        },
        computed: {
            poles () {
                const poles = this.$store.state.pole.filter(p => p.category === this.localModel.category)
                return poles;
            }
        }
    }
</script>

<style scoped lang="scss">
    .survey {
        border: 1px dotted gray;
        display: inline-block;
        position: relative;
        /*width: 100%;*/

        border-radius: 20px;

        .actions {
            background: gainsboro;
        }

        ul {
            margin: 0;
            padding-left: 17px;
        }
    }
</style>